import React from 'react'
import {PaymentCheckoutDetail} from '../containers'

export default function PaymentCheckoutDetailScreen() {
  return <PaymentCheckoutDetail />
}
